// extracted by css-extract-rspack-plugin
export default {"cls1":"Truncate-cls1_USv","cls2":"Truncate-cls2_EYv Truncate-cls1_USv"};